import React from 'react';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { Button } from 'antd';
import dayjs from 'dayjs';
import { ExportOutlined } from '@ant-design/icons';
import { IDoOrder } from '@/interfaces/doOrder';
import { formatDate } from '@/utils/dataUtils';

interface IProps {
  data: IDoOrder[];
}

const ExcelExport = ({ data }: IProps) => {
  const handleExport = async () => {
    // Create a new workbook and add a worksheet
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Sheet1');

    // Add custom headers with color
    worksheet.columns = [
      { header: '#', key: 'id', width: 10 },
      { header: 'DO NUMBER', key: 'code', width: 20 },
      { header: 'INV NUMBER', key: 'ivNo', width: 20 },
      { header: 'INV DATE', key: 'ivDate', width: 15 },
      { header: 'ITEM CODE', key: 'productCode', width: 20 },
      { header: 'ITEM NAME', key: 'productName', width: 40 },
      { header: 'DO QTY', key: 'quantity', width: 10 },
      { header: 'UNIT', key: 'productUnitName', width: 20 },
      { header: 'REQUEST ETD SIN DATE', key: 'requestEtdDate', width: 20 },
      { header: 'REQUEST ETA BKK DATE', key: 'requestEtaDate', width: 20 },
      { header: 'ARRIVAL DATE', key: 'arrivalDate', width: 20 },
      { header: 'RECEIVED DATE', key: 'receivedDate', width: 20 },
      { header: 'INBOUND QTY', key: 'inboundQty', width: 15 },
      { header: 'RECEIVED QTY', key: 'receivedQty', width: 15 },
    ];

    // Style the header row
    worksheet.getRow(1).eachCell(cell => {
      cell.font = { bold: true, color: { argb: 'FFFFFFFF' } }; // White text
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FF0000FF' }, // Blue background
      };
    });

    let idx = 1;

    // Add data to the worksheet
    data.forEach(item => {
      if (item.inboundItems?.length) {
        item.inboundItems.forEach(ibitem => {
          worksheet.addRow({
            id: idx++,
            code: item.code,
            ivNo: ibitem.invNO,
            ivDate: formatDate(dayjs(ibitem.invDate)),
            productCode: item.productCode,
            productName: item.productName,
            quantity: item.quantity,
            productUnitName: item.productUnitName,
            requestEtdDate:
              item.requestEtdSin && formatDate(dayjs(item.requestEtdSin)),
            requestEtaDate:
              item.requestEtaBkk && formatDate(dayjs(item.requestEtaBkk)),
            arrivalDate:
              ibitem.arrivalDate && formatDate(dayjs(ibitem.arrivalDate)),
            receivedDate:
              ibitem.whReceivedDate && formatDate(dayjs(ibitem.whReceivedDate)),
            inboundQty:
              ibitem.baseUnitId == 'KG' ? ibitem?.totalUnit : ibitem?.totalUnit,
            receivedQty: ibitem.totalReceivedQty,
          });
        });
      } else {
        worksheet.addRow({
          id: idx++,
          code: item.code,
          ivNo: '',
          ivDate: '',
          productCode: item.productCode,
          productName: item.productName,
          quantity: item.quantity,
          productUnitName: item.productUnitName,
          requestEtdDate:
            item.requestEtdSin && formatDate(dayjs(item.requestEtdSin)),
          requestEtaDate:
            item.requestEtaBkk && formatDate(dayjs(item.requestEtaBkk)),
          arrivalDate: '',
          receivedDate: '',
          receivedQty: '',
          inboundQty: '',
        });
      }
    });

    // Generate the Excel file and trigger the download
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    saveAs(blob, `do-report-${dayjs().format('YYYY-MM-DD')}.xlsx`);
  };

  return (
    <div>
      <Button type="primary" ghost onClick={handleExport}>
        <ExportOutlined /> Export to Excel
      </Button>
    </div>
  );
};

export default ExcelExport;
